import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/subscriptions/subscription/:id/';

type MutationFnType = typeof mutationFn;

interface DTO {
    id: string;
}
const mutationFn = ({ id }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { id }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteSubscription };
